export const fsPath = 'trihow-core/src';
